import { render, staticRenderFns } from "./EmailAuditList.vue?vue&type=template&id=0b21b76a&scoped=true"
import script from "./EmailAuditList.vue?vue&type=script&lang=js"
export * from "./EmailAuditList.vue?vue&type=script&lang=js"
import style0 from "./EmailAuditList.vue?vue&type=style&index=0&id=0b21b76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21b76a",
  null
  
)

export default component.exports